import {useState, useEffect} from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Box from "@mui/material/Box";

import Loading from '../../common/Loading';


export default function LoadListFilterOrderList(props) {
    //console.debug("RTS Break LoadListFilterOrderList");

    const [isLoading, setIsLoading] = useState(true);

    const [orders, setOrders] = useState();
    const [repoOrders, setRepoOrders] = useState();


    useEffect(() => {
        if(props.orders===null){
            setOrders([]);
        }
        else{
            setOrders(props.orders);
        }

        if(props.data===null){
            setRepoOrders([]);
        }
        else{
            setRepoOrders(props.data);
        }

        setIsLoading(false);
    }, [props]); 


    function valChange(e, val){
        props.setOrdersFx(val);
        setOrders(val);
    }


    if(isLoading){
        return(
            <Loading />
        );
    }


    return(
        <>
            <Autocomplete
                options={repoOrders}
                renderInput={(params) => <TextField {...params} label="Purchase Orders" size="small" />}
                value={orders}
                onChange={valChange}
                getOptionLabel={(order) => order}
                renderOption={(props, repoOrders) => (
                    <Box component="li" {...props} key={repoOrders}>
                        {repoOrders}
                    </Box>
                )}
                multiple
            />
        </>
    );
}

